/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
} from './AdmissionStatusCode';

/**
 * 
 * @export
 * @interface LegalTransition
 */
export interface LegalTransition {
    /**
     * Target admission-status code. `none` on a `revert` means
     * the revert clears the status entirely.
     * 
     * @type {AdmissionStatusCode}
     * @memberof LegalTransition
     */
    to_status: AdmissionStatusCode;
    /**
     * `allowed` — render and clickable.
     * `disabled` — render but greyed out (caller should also read `reason`).
     * `absent` — do not render.
     * 
     * @type {string}
     * @memberof LegalTransition
     */
    verdict: LegalTransitionVerdictEnum;
    /**
     * `revert` is the back-edge to the lead's immediately-previous
     * status (rendered as Undo). `forward` is everything else.
     * 
     * @type {string}
     * @memberof LegalTransition
     */
    kind: LegalTransitionKindEnum;
    /**
     * Populated when `verdict` is `disabled`.
     * @type {string}
     * @memberof LegalTransition
     */
    reason?: string;
}


/**
 * @export
 */
export const LegalTransitionVerdictEnum = {
    Allowed: 'allowed',
    Absent: 'absent',
    Disabled: 'disabled'
} as const;
export type LegalTransitionVerdictEnum = typeof LegalTransitionVerdictEnum[keyof typeof LegalTransitionVerdictEnum];

/**
 * @export
 */
export const LegalTransitionKindEnum = {
    Forward: 'forward',
    Revert: 'revert'
} as const;
export type LegalTransitionKindEnum = typeof LegalTransitionKindEnum[keyof typeof LegalTransitionKindEnum];


/**
 * Check if a given object implements the LegalTransition interface.
 */
export function instanceOfLegalTransition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "to_status" in value;
    isInstance = isInstance && "verdict" in value;
    isInstance = isInstance && "kind" in value;

    return isInstance;
}

export function LegalTransitionFromJSON(json: any): LegalTransition {
    return LegalTransitionFromJSONTyped(json, false);
}

export function LegalTransitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalTransition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'to_status': AdmissionStatusCodeFromJSON(json['to_status']),
        'verdict': json['verdict'],
        'kind': json['kind'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function LegalTransitionToJSON(value?: LegalTransition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'to_status': AdmissionStatusCodeToJSON(value.to_status),
        'verdict': value.verdict,
        'kind': value.kind,
        'reason': value.reason,
    };
}

